// src/features/business-functions/components/AccountHeader.jsx
import React from 'react';
import { Box, Typography, Skeleton } from '@mui/material';
import { ACCOUNT_STATUS } from '../constants/accountConstants';

/**
 * Account page header — displays account name, status badge, description,
 * and action buttons.
 *
 * Pure presentational — receives all data and callbacks via props.
 */
export default function AccountHeader({ account, styles, isLoading }) {
  if (isLoading || !account) {
    return (
      <Box sx={styles.accountHeaderRoot}>
        <Box sx={styles.accountHeaderLeft}>
          <Skeleton variant="text" width={260} height={36} />
          <Skeleton variant="text" width={400} height={20} />
        </Box>
      </Box>
    );
  }

  const isActive = account.status === ACCOUNT_STATUS.ACTIVE;
  const statusSx = isActive ? styles.statusBadgeActive : styles.statusBadgeInactive;
  const statusLabel = isActive ? 'Active' : 'Inactive';

  return (
    <Box sx={styles.accountHeaderRoot}>
      <Box sx={styles.accountHeaderLeft}>
        <Box sx={styles.accountTitleRow}>
          <Typography component="h1" sx={styles.accountTitle}>
            {account.name}
          </Typography>
          <Box component="span" sx={statusSx}>
            {statusLabel}
          </Box>
        </Box>

        {account.description && (
          <Typography sx={styles.accountDescription}>
            {account.description}
          </Typography>
        )}
      </Box>
    </Box>
  );
}
